import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Calendar } from '@app/domain/one_to_one/model/calendar.model';
import { Observable } from 'rxjs';
import { CalendarService } from '@app/shared/api/interfaces/calendar.service';
import { CalendarConnectionStatus } from '@app/domain/one_to_one/model/calendar-connected.model';
import { SSOProvider } from '@app/models/auth/sso-provider.enum';
import { SKIP_GENERIC_ERROR_DIALOG } from '@app/shared/interceptors/http.error.interceptor';

@Injectable({
  providedIn: 'root'
})
export class CalendarAPIService implements CalendarService {
  public readonly BASE_URL = '/api/calendar';

  constructor(private http: HttpClient) { }

  isConnected(): Observable<CalendarConnectionStatus> {
    const url = `${this.BASE_URL}/connected`;
    return this.http.get<CalendarConnectionStatus>(url);
  }

  getAvailability(emails: string[], startDateTime: string, endDateTime: string, timezone: string): Observable<Calendar[]> {
    const request = {
      emails,
      startDateTime,
      endDateTime,
      timezone
    };

    const url = `${this.BASE_URL}/availability`;
    return this.http.post<Calendar[]>(url, request);
  }

  // The SSO callback shows a failed connect's reason itself, so the generic error dialog is skipped.
  connect(provider: SSOProvider, authorizationCode: string): Observable<CalendarConnectionStatus> {
    const url = `${this.BASE_URL}/connect`;
    const context = new HttpContext().set(SKIP_GENERIC_ERROR_DIALOG, true);
    return this.http.post<CalendarConnectionStatus>(url, { provider, authorizationCode }, { context });
  }

  // The Notifications page shows a failed disconnect's reason itself, so the generic error dialog is skipped.
  disconnect(): Observable<CalendarConnectionStatus> {
    const url = `${this.BASE_URL}/disconnect`;
    const context = new HttpContext().set(SKIP_GENERIC_ERROR_DIALOG, true);
    return this.http.post<CalendarConnectionStatus>(url, {}, { context });
  }
}
